<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 16:16:08
 * @LastEditTime: 2020-05-25 15:46:10
 * @Description: 新建试卷步骤
 -->
<template>
  <i-steps :current="current" class="create-step">
    <i-step title="上传必考题目"></i-step>
    <i-step title="题库组题"></i-step>
    <i-step title="生成试卷"></i-step>
  </i-steps>
</template>

<script>
export default {
  name: 'CreateTestPaperStep',
  props: {
    current: { type: Number, required: true },
  },
};
</script>

<style lang="less" scoped>
.create-step {
  padding: 20px 120px;

  /deep/ .ivu-steps-title,
  /deep/ .ivu-steps-head {
    background: #fbf9fb;
  }
}
</style>
